<template>
  <loading-container :state="state" errormsg="Beim Laden der Kommentare ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder wenden Sie sich an den Seiten Administrator">
    <new-comment-box :threadId="threadId" @newComment="reloadComments" />
    <template
        v-for="comment in comments"
        :key="comment.id">
      <div
          v-if="isNotDeletedOrHasAnswers(comment)"
          class="comment p-12 d-flex align-items-start" >
        <single-comment
            v-if="renderSingleCommentsOnLikesUpdate"
            :comment="comment"
            :threadId="threadId"
            :forceShowDeleteCommentButtons="forceShowDeleteCommentButtons"
            @newCommentReply="reloadComments"
            @commentDeleted="reloadComments"
            @likesUpdated="rerenderSingleCommentsOnLikesUpdate"
        />
      </div>
    </template>
  </loading-container>
</template>
<script lang="ts">

import { Comment } from '@/generated/openapi';
import commentService from '@/services/commentService';
import { defineComponent } from 'vue'
import NewCommentBox from './NewCommentBox.vue';
import LoadingMixin from '@/mixins/LoadingMixin'
import LoadingContainer from '../structure/LoadingContainer.vue'
import SingleComment from './SingleComment.vue';



export default defineComponent({
  name: 'CommentsList',
  components: {
    NewCommentBox,
    SingleComment,
    LoadingContainer
  },
  mixins: [
    LoadingMixin
  ],
  props: {
    threadId: String,
    parentThreadId: String,
    forceShowDeleteCommentButtons: Boolean,
  },
  emits: ['commentsChanged'],
  data() {
    return {
      threadIdLocal: '',
      comments: [] as Comment[],
      showAnswerBox: false,
      renderSingleCommentsOnLikesUpdate: true
    };
  },
  mounted() {
    if (this.threadId !== undefined) {
      this.threadIdLocal = this.threadId
    }
    if (this.parentThreadId === undefined) {
      this.reloadComments()
    }
  },
  computed: {

  },

  methods: {
    reloadComments(): void {
      commentService.getComments(this.threadIdLocal, true).then((ct) => {
        if(ct.comments !== undefined) {
          this.comments = ct.comments.reverse()
          this.$emit('commentsChanged')
        }
        this.handleSuccess()
      }).catch(this.handleError)
    },
    rerenderSingleCommentsOnLikesUpdate(): void {
      this.renderSingleCommentsOnLikesUpdate = false
      this.$nextTick(() => {
        this.renderSingleCommentsOnLikesUpdate = true
      })
    },
    isNotDeletedOrHasAnswers(comment: Comment): boolean{
      if (comment.deleted === true ) {
        if(comment.replies !== undefined && comment.replies?.length > 0) {
          // Check if there is a undeleted answer. If yes, we need to show the deleted comment.
          for (let i = 0; i < comment.replies.length; i++) {
            if (comment.replies[i].deleted !== true) {
              return true
            }
          }
        }

        // deleted comment without children
        return false

      }
      return true
    }
  }

});

</script>
